class LinkedCollectionsNav extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  static async whenFacetFiltersForm() {
    try {
      return await customElements.whenDefined('facet-filters-form');
    } catch {
      return null;
    }
  }

  static normalizePath(urlString) {
    try {
      return new URL(urlString, window.location.origin).pathname.replace(/\/$/, '') || '/';
    } catch (e) {
      return '';
    }
  }

  async onClick(event) {
    const btn = event.target.closest('[data-collection-url]');
    if (!btn || !this.contains(btn)) return;

    const targetUrl = btn.getAttribute('data-collection-url');
    if (!targetUrl) return;

    const targetPath = LinkedCollectionsNav.normalizePath(targetUrl);
    const currentPath = LinkedCollectionsNav.normalizePath(window.location.pathname);
    if (targetPath === currentPath) return;

    const FacetForm = await LinkedCollectionsNav.whenFacetFiltersForm();
    if (!FacetForm) return;

    const productGrid = document.getElementById('product-grid');
    const gridContainer = document.getElementById('ProductGridContainer');
    if (!productGrid || !gridContainer) return;

    const sectionId = productGrid.dataset.id;
    if (!sectionId) return;

    const fetchUrlObj = new URL(targetUrl, window.location.origin);
    fetchUrlObj.searchParams.set('section_id', sectionId);
    const fetchUrl = `${fetchUrlObj.pathname}${fetchUrlObj.search}`;

    const collectionEl = gridContainer.querySelector('.collection');
    if (collectionEl) collectionEl.classList.add('loading');
    document.querySelectorAll('.thb-filter-count').forEach((el) => el.classList.add('loading'));
    this.querySelectorAll('[data-collection-url]').forEach((b) => {
      b.disabled = true;
    });

    try {
      const response = await fetch(fetchUrl);
      if (!response.ok) {
        throw new Error(`Linked collections section fetch failed: HTTP ${response.status}`);
      }
      const html = await response.text();

      FacetForm.filterData = [];
      FacetForm.searchParamsPrev = '';
      FacetForm.searchParamsInitial = '';

      FacetForm.renderFilters(html, null);
      FacetForm.renderProductGridContainer(html);
      FacetForm.renderProductCount(html);

      if (typeof FacetsToggle !== 'undefined') {
        new FacetsToggle();
      }

      history.pushState({ searchParams: '' }, '', fetchUrlObj.pathname);

      this.querySelectorAll('.linked-collections__item').forEach((el) => {
        el.classList.remove('linked-collections__item--active');
      });
      this.querySelectorAll('[data-collection-url]').forEach((b) => {
        b.setAttribute('aria-pressed', 'false');
      });
      btn.closest('.linked-collections__item')?.classList.add('linked-collections__item--active');
      btn.setAttribute('aria-pressed', 'true');
    } catch (e) {
      console.error(e);
    } finally {
      const collectionElAfter = document.getElementById('ProductGridContainer')?.querySelector('.collection');
      if (collectionElAfter) collectionElAfter.classList.remove('loading');
      document.querySelectorAll('.thb-filter-count').forEach((el) => el.classList.remove('loading'));
      this.querySelectorAll('[data-collection-url]').forEach((b) => {
        b.disabled = false;
      });
    }
  }
}

customElements.define('linked-collections-nav', LinkedCollectionsNav);
